import { EditorialDashboardPageReducers } from './containers/EditorialDashboardPage';

export default from './DashboardPage';

export const DashboardPageReducers = {
  ...EditorialDashboardPageReducers,
};
